import {container} from "tsyringe";
import {CommandSendListener} from "./command-send.listener";
import {EntityChangeListener} from "./entity-change.listener";
import {EntityCreatedListener} from "./entity-created.listener";
import {EntityDeletedListener} from "./entity-deleted.listener";

// Initialize Message Broker Listeners
container.resolve(CommandSendListener);
container.resolve(EntityCreatedListener);
container.resolve(EntityChangeListener);
container.resolve(EntityDeletedListener);
